define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/store/Memory",
	"csi",
	"csi/action/Controller",
	"csi/comm/PostRequest",
	"csi/form/Widget",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"csi/xml/Query",
	"Apparel/ProductType",
	"./MassReplaceProductStructureForm"
], function(array,declare,lang,Memory,csi,Controller,PostRequest,FormWidget,ActionControllerMixin,xml,Query,ProductType) {

	var	FIELD_TO = "ProductStructureMassReplaceTo";

	return declare([Controller, ActionControllerMixin], {
		getFormData: function() {
			// summary: make sure that at least one Style is selected
			var	fd = this.inherited(arguments);
			fd.m_bRequireOne = true;
			fd.m_fAggregateTest = lang.hitch(this, this._canSelectStyle);
			return fd;
		},

		getWizardViewQuery: function(/*csi.wizard.Widget*/wizard, /*csi.view.Widget*/view, /*Number*/index) {
			// summary: return query for Styles view
			var	q;

			if (index == 1) {
				if (!view.isStarted()) {
					// add existing filters from table view - only needs to be done first time
					view.copyQuery(this.widget);
				}
			}

			return q;
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard,
							 /*csi.wizard.Content*/currentPage,
							 /*csi.wizard.Content*/nextPage,
							 /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			return bFinish ? null : wizard.setFormDataToPage(nextPage, this.m_formData, (wizard.getIndexOfPage(nextPage) == 1));
		},

		process: function() {
			// summary: issue request as PostRequest so we get return value
			var	fd = this.m_formData;

			var req = new PostRequest("MaterialSpec", "StyleMassReplaceProductStructure")
				.addParameter(xml.PROP_URL_PARENT, this.m_urlParent)
				.addParameter("ProductStructureMassReplaceTo", fd.getFieldValue(FIELD_TO));

			var	nodes = fd.getSelectedNodes(true);
			if (nodes.length) {
				req.addParameter(xml.PROP_AGGREGATE_ADDS, array.map(nodes, xml.nodeGetURL));
			}

			req.post({}).then(lang.hitch(this, this._onPublishResponse));
		},

		postProcessSuccess: function() {
			// summary: refresh data in where-used table
			this.widget.refreshData();
		},

		_canSelectStyle: function(/*Context*/ctx, /*FormData*/fd) {
			// summary: allow selection only of nodes with Write access
			var style = ctx.getNode();
			if (!xml.nodeHasRight(this.m_cache.getNode(style.Spec), xml.RIGHT_WRITE)) {
				return false;
			}

			return array.every(style.DataSheets, function(dsURL) {
				var dataSheet = this.m_cache.getNode(dsURL);
				return dataSheet.$Type != "ApparelBOM" || this._bomIsAcceptable(dataSheet);
			}, this);
		},

		_bomIsAcceptable: function(bom) {
			var bomRev = this.m_cache.getNode(bom.CurrentRevision);
			if (bomRev.BOMStructure != this.m_urlParent) {
				return true;
			}

			if (bom.Revisions.length != 1 || bomRev.State != "Revision.State:DRAFT") {
				return false;
			}

			return xml.nodeHasRight(bomRev, xml.RIGHT_WRITE);
		}
	});
});